import Currency from "../../entities/Currency";
import PaymentTypeResponse from "./PaymentTypeResponse";
import PaymentType from "../../entities/PaymentType";

class OrderPaymentResponse {
    public amount: number;
    public currency: Currency;
    public paymentTypeResponse: PaymentTypeResponse;
    public paymentType: PaymentType;
    public createdAt: number;
    public userId: string;
    public isEditable: boolean;

    constructor(
        amount: number,
        currency: Currency,
        paymentType: PaymentTypeResponse,
        createdAt: number,
        userId: string,
        isEditable: boolean,
    ) {
        this.paymentTypeResponse = paymentType;
        this.amount = amount;
        this.currency = currency;
        this.paymentType = this.paymentTypeResponse.paymentType;
        this.createdAt = createdAt;
        this.userId = userId;
        this.isEditable = isEditable;
    }

    get getExtraFee(): number {
        console.log(1111, this.amount)
        if (this.paymentTypeResponse.value !== 0) {
            if (this.paymentTypeResponse.isPercentage) {
                return this.amount * this.paymentTypeResponse.value / 100.00;
            }
            return this.paymentTypeResponse.value
        }
        return 0;
    }

}

export default OrderPaymentResponse;